// extracted by mini-css-extract-plugin
export var cardIcon = "_4f-4";
export var checkboxCard = "_4f-0";
export var checkboxCardSelected = "_4f-1";
export var disabled = "_4f-2";
export var outerBorder = "_4f-3";
export var spacerMedium = "_4f-7";
export var spacerSmall = "_4f-6";
export var spacerXsmall = "_4f-5";